import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import Table from 'react-bootstrap/Table';




function AffichageClassement(props) {

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [classement, setClassement] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;






useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/classement/affichage/${props.userData.user.donnée.results[0].id_equipe}`,
        );
        setClassement(response.data);
        setError(null);
        setIsLoading(false);


      } catch (error) {
        if (error.response) {
            
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
        setIsLoading(false);

      }
    };

    fetchData(); 
  }, [apiUrl, props.userData]);
  

    if (isLoading) {
         return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }






  return (
  <>
  {props.userData && classement ? (
    <>
    <div className="joueur equipe">
        <div className="image7"><img src='/img/bel.png'  alt="logo de l'Union Belge de football" width="100" height="100"/></div>
         <div className="nbr">{classement.classement[0].nom}</div>
         <br/>
    </div>
    <hr></hr>
    <div className="wrapper">
    <Table striped bordered hover>
          <thead>
            <tr>
              <th>Rang</th>
              <th>Team</th>
              <th>M</th>
              <th>V</th>
              <th>N</th>
              <th>D</th>
              <th>Buts</th>
              <th>+/-</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
                   {classement && classement.classement.map((item, index) => (
                    <tr key={index} >
                                       <td className="rank">{item.position}</td>
                                       <td className="team">{item.equipe}</td>
                                       <td className="matchs">{item.matchs}</td>
                                       <td className="win">{item.victoires}</td>
                                       <td className="match_nul">{item.nul}</td>
                                       <td className="loose">{item.défaites}</td>
                                       <td className="buts">{item.buts}</td>
                                       <td className="diff">{item.différence}</td>
                                       <td className="points">{item.points}</td>
                    </tr>
                 ))}

              </tbody>
            </Table>
    </div>
             
      </>
      ) :(
        <>      
      <div id="alert-message" className="alert5" >
          <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
      </div></>
      )}
  </>
  );
}

export default AffichageClassement;
